import React from "react";
import { useDropboxFolder } from "src/hooks/useDropboxFolder";
import { Box } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import TablaContratoSeleccionado from "./TablaContratoSeleccionado";
import { useClienteActual } from "src/hooks/useClienteActual";
import { useObtenerContratosClienteQuery } from "../../../services/accesoClientesApi";
import TableSkeleton from "src/components/cliente/loading/TableSkeleton";

export default function ContratosClienteSeleccionado(props) {
  const { value, cliente } = props;
  const { rut } = useClienteActual();
  // RTK Query - Obtener contratos del cliente
  const {
    data: contratos = [],
    isLoading,
    isError,
    error,
  } = useObtenerContratosClienteQuery(rut, {
    skip: !rut || value !== 3,
  });

  // Asegurar que existe carpeta de Contratos en Dropbox
  useDropboxFolder(cliente?.rut ? `/Clientes/${cliente.rut}/Contratos` : null);

  return (
    <>
      {value === 3 && (
        <>
          {/* Estado de carga */}
          {isLoading && <TableSkeleton rows={4} columns={3} />}

          {/* Estado de error */}
          {isError && (
            <Box sx={{ width: "100%", p: 2 }}>
              <Alert severity="error">
                Error al cargar los contratos. Por favor, intenta nuevamente.
                {error?.data?.message && ` (${error.data.message})`}
              </Alert>
            </Box>
          )}

          {/* Datos cargados correctamente */}
          {!isLoading && !isError && (
            <>
              {contratos.length > 0 ? (
                <TablaContratoSeleccionado contratos={contratos} />
              ) : (
                <Box sx={{ width: "100%", p: 2 }}>
                  <Alert severity="info">
                    No se encontraron contratos para este cliente.
                  </Alert>
                </Box>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
